(function () {
  'use strict';

  angular
    .module('bossApp')
    .config(configRoute);
  configRoute.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];

  function configRoute ($stateProvider, $urlRouterProvider, $locationProvider) {

    /*var globalStorage = localStorage.getItem('AccountsFilter');
    _resolveFIXBoss(globalStorage);

    function _resolveFIXBoss (globalStorage) {
      if (!globalStorage) {
        globalStorage = '[]';
        localStorage.setItem('AccountsFilter', globalStorage);
      }
    }*/

    // $locationProvider.html5Mode(true);

    $locationProvider.hashPrefix('');
    $stateProvider
      .state('login', {
        url: '/',
        inherit: true,
        hiddenParam: false,
        params: {
          cid: null
        },
        template: '<login class="has-header"></login>'
      })
      .state('login.openWebForm', {
        url: 'openWebForm/:formId',
        views: {
          openWebForm: {
            templateProvider: openWebFormTemplate
          }
        }
      })
      .state('login.openWebForm.success', {
        url: '/success',
        views: {
          success: {
            templateUrl: 'src/app/components/login/modal-success.html',
            controller: successFormController
          }
        }
      });
    openWebFormTemplate.$inject = ['$transition$'];

    function openWebFormTemplate ($transition$) {
      var formSrc = 'https://d1z5tqtqqbiamk.cloudfront.net/' + $transition$.params().formId;
      return '<div class="full-screen" ui-view="success"><iframe src="' + formSrc + '"></iframe></div>';
    }

    successFormController.$inject = ['openwebPath', '$scope'];

    function successFormController (openwebPath, $scope) {
      $scope.openwebPath = openwebPath;
    }

    // if the path doesn't match any of the urls you configured
    // otherwise will take care of routing the user to the specified url.
    $urlRouterProvider.otherwise('/');

  }

})();
